import { OptionProps } from '@n2-common/ui/Select';
import { TFunction } from 'i18next';

const martialStatusValue = ['C', 'T', 'M', 'S', 'W'] as const;
export type MartialStatusValues = typeof martialStatusValue[number];

export const martialStatusValues = (t: TFunction): OptionProps<MartialStatusValues>[] => [
    { text: t<string>('MartialStatus.Cohabitant'), value: 'C' },
    { text: t<string>('MartialStatus.Separated'), value: 'T' },
    { text: t<string>('MartialStatus.Married'), value: 'M' },
    { text: t<string>('MartialStatus.Single'), value: 'S' },
    { text: t<string>('MartialStatus.Widowed'), value: 'W' },
];

export const trueFalseValues = (t: TFunction) => [
    { text: t<string>('SelectOption.No'), value: 'false' },
    { text: t<string>('SelectOption.Yes'), value: 'true' },
];
const employmentStatusCodes = ['F', 'B', 'I', 'P', 'R', 'S', 'U', 'A', 'T'] as const;
export type EmploymentStatusCode = typeof employmentStatusCodes[number];

export const employmentStatusCodeNo: OptionProps<EmploymentStatusCode>[] = [
    { text: 'Fast ansatt', value: 'F' },
    { text: 'Uføretrygdet', value: 'B' },
    { text: 'Selvstendig næringsdrivende', value: 'I' },
    { text: 'Midlertidig/prosjekt', value: 'P' },
    { text: 'Pensjonist', value: 'R' },
    { text: 'Student', value: 'S' },
    { text: 'Uten arbeid / hjemmeværende', value: 'U' },
    { text: 'Arbeidsavklaring', value: 'A' },
];

export const employmentStatusCodeSe: OptionProps<EmploymentStatusCode>[] = [
    { text: 'Fast anställd', value: 'F' },
    { text: 'Egenföretagare', value: 'I' },
    { text: 'Timanställd', value: 'P' },
    { text: 'Pensionär/sjukpensionär', value: 'R' },
    { text: 'Student', value: 'S' },
    { text: 'Arbetslös', value: 'U' },
];

export const employmentStatusCodeFi: OptionProps<EmploymentStatusCode>[] = [
    { text: 'Vakituinen', value: 'F' },
    { text: 'Osa-aikainen', value: 'P' },
    { text: 'Yrittäjä', value: 'I' },
    { text: 'Eläkkeellä', value: 'R' },
    { text: 'Työtön', value: 'U' },
    { text: 'Opiskelija', value: 'S' },
];

const accomodationStatusValues = ['A', 'C', 'H', 'P', 'O', 'R'] as const;
export type AccomodationStatusValue = typeof accomodationStatusValues[number];

export const accommodationStatusCodesNo: OptionProps<AccomodationStatusValue>[] = [
    { text: 'Selveier leilighet', value: 'A' },
    { text: 'Borettslag', value: 'C' },
    { text: 'Enebolig', value: 'H' },
    { text: 'Bor hos foreldre', value: 'P' },
    { text: 'Leier', value: 'R' },
    { text: 'Annet', value: 'O' },
];

export const accommodationStatusCodesSe: OptionProps<AccomodationStatusValue>[] = [
    { text: 'Bostadsrätt', value: 'A' },
    { text: 'Hus', value: 'H' },
    { text: 'Bor med föräldrarna', value: 'P' },
    { text: 'Hyresrätt', value: 'R' },
    { text: 'Annat', value: 'O' },
];

export const accommodationStatusCodesFi: OptionProps<AccomodationStatusValue>[] = [
    { value: 'A', text: 'Omistus - kerrostalo tai rivitalo' },
    { value: 'C', text: 'Asumisoikeusasunto' },
    { value: 'H', text: 'Omistus - omakotitalo tai paritalo' },
    { value: 'P', text: 'Vanhempien luona' },
    { value: 'R', text: 'Vuokralla' },
    { value: 'O', text: 'Muu' },
];
